var TEXT_BOX_WIDTH_CALCULATION_OPTIONS = {
    PERCENT: 'PERCENT',
    MANUAL: 'MANUAL',
};
export default TEXT_BOX_WIDTH_CALCULATION_OPTIONS;
//# sourceMappingURL=textBoxWidthCalculationOptions.js.map